module.exports = __webpack_public_path__ + "img/the-platform-logo-icon.067b7b9e.svg";